// src/api.js

// --- API Configuration ---
export const API_BASE_URL = 'https://caroftheyear.mobilitymedia.my/admin'; // <-- UPDATED
export const API_SUBMIT_FORM = `${API_BASE_URL}/api/save_campaign`;
export const API_CHECK_MOBILE = `${API_BASE_URL}/api/check_mobile`; // <-- NEW
export const mockApiCarList = [
    { id: 'byd_m6', name: 'BYD M6', imageUrl: '/assets/cars/car-byd-m6.png' },
    { id: 'denza_d9', name: 'Denza D9', imageUrl: '/assets/cars/car-Denza-D9.png' },
    { id: 'gac_m8', name: 'GAC M8', imageUrl: '/assets/cars/car-GAC-M8.png' },
    { id: 'hyundai_staria', name: 'Hyundai Staria', imageUrl: '/assets/cars/car-hyundai-staria.png' },
    { id: 'xpeng_x9', name: 'XPeng X9', imageUrl: '/assets/cars/car-xpeng.png' },
    { id: 'zenkr_009', name: 'Zenkr 009', imageUrl: '/assets/cars/car-zeekr.png' },
];

// export const ratingCriteria = [
//     { id: 'design', label: 'Design & Styling' },
//     { id: 'driving', label: 'Driving Experience' },
//     { id: 'tech', label: 'Tech & Features' },
//     { id: 'value', label: 'Value For Money' },
//     { id: 'space', label: 'Space & Practicality' },
//     { id: 'interest', label: 'Are you interested in this car?' },
// ];

/**
 * Simulates fetching the list of cars for a given type.
 * @param {string} carType - The type of car (e.g., 'MPV')
 */
export function fetchCarList(carType) {
    console.log(`API Call: Fetching car list for type: ${carType}`);
    return new Promise(resolve => {
        setTimeout(() => {
            if (carType === 'MPV') {
                resolve(mockApiCarList);
            } else {
                resolve([]);
            }
        }, 1000); // 1-second delay
    });
}

/**
 * Simulates submitting all collected data to the server.
                                 
 * @param {object} data - The complete data payload
 */
export async function submitAllData(data) {
    console.log("API Call: Submitting final data to:", API_SUBMIT_FORM);
    console.log("Payload:", JSON.stringify(data, null, 2));

    try {
        const response = await fetch(API_SUBMIT_FORM, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            // Server returned an error (e.g., 400, 500)
            const errorData = await response.json().catch(() => ({})); // Try to parse error, or use empty obj
            console.error('Server Error:', response.status, errorData);
            return { success: false, message: `Server Error: ${errorData.message || response.statusText}` };
        }

        // Server returned a successful response
        const result = await response.json();
        console.log("API Success:", result);
        return { success: true, message: "Data received", data: result };

    } catch (error) {
        // Network error (e.g., no internet, DNS fail)
        console.error('Network Error:', error);
        return { success: false, message: 'Submission failed. Please check your connection.' };
    }
}

/**
 * NEW: Checks if a mobile number is already in the database.
 * @param {string} mobile - The mobile number to check.
 * @returns {Promise<object>} - { isDuplicate: boolean, error: string|null }
 */
export async function checkMobileDuplicate(mobile) {
    console.log("API Call: Checking mobile number at:", API_CHECK_MOBILE);
    try {
        const response = await fetch(API_CHECK_MOBILE, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ mobile: mobile })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error('Server Error checking mobile:', response.status, errorData);
            return { isDuplicate: false, error: `Server Error: ${errorData.message || 'Could not validate mobile'}` };
        }

        const result = await response.json(); // Assuming { "isDuplicate": true/false }
        console.log("Mobile check result:", result);
        return { isDuplicate: result.isDuplicate || false, error: null };

    } catch (error) {
        console.error('Network Error checking mobile:', error);
        return { isDuplicate: false, error: 'Network error. Please check connection.' };
    }
}